module.exports = __webpack_public_path__ + "img/提现记录.d813e30e.png";